// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"ee5a9249","596":"96caf99e","983":"1ebf5ee8"}[chunkId] + ".chunk.js";
};